'use strict';

const isInViewport = require('./modules/helpers/isInViewport');
const isAboveViewport = require('./modules/helpers/isAboveViewport');
const $backToTop = $('.js-scrolltotop');

function backButtonPosition() {
    const stayInformed = $('.stay-informed');

    if (stayInformed.length) {
        const elementIsInView = isInViewport(stayInformed) || isAboveViewport(stayInformed);
        if (elementIsInView) {
            $backToTop.addClass('not-fixed');
            $backToTop.css('margin-bottom', stayInformed.outerHeight());
            return;
        }

        $backToTop.removeClass('not-fixed').css('margin-bottom', '');
        return;
    }
    const bigFooter = $('.js-footer');
    let $endPoint = $('.footer');

    if (bigFooter.length) {
        $endPoint = bigFooter;

        if (isInViewport($endPoint)) {
            $backToTop.addClass('not-fixed');
            return;
        }
    }

    $backToTop.removeClass('not-fixed');
}

function initializeEvents() {
    const viewportHeight = $(window).height();
    let prevScroll = $(document).scrollTop();

    if ($backToTop.length > 0 && !$('.sticky-bar').length) {
        $(window).on('scroll', function() {
            const offsetFromTop = $(window).scrollTop();
            const newScroll = $(document).scrollTop();

            if (offsetFromTop > viewportHeight) {
                $backToTop.addClass('shown');

                if (newScroll < prevScroll) {
                    $backToTop.addClass('shown').removeClass('hide-on-mobile');
                } else {
                    $backToTop.addClass('hide-on-mobile');
                }
                prevScroll = newScroll;
            } else {
                $backToTop.removeClass('shown');
            }

            backButtonPosition();
        });
    }

    if ($('.sticky-bar').length) {
        $('.js-scrolltotop').remove();
    }
}

const backtotop = {
    init: function() {
        initializeEvents();
        backButtonPosition();
    }
};

module.exports = backtotop;
